import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector, submit } from 'redux-form';

import { STATIC_ROOT } from '../../constants';

import { sendGiveawayParticipationRequest, reset } from '../../services/giveaway/actions';

import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import SvgComponent from '../SvgComponent';
import { FormComponent, CheckboxInputFieldComponent, LegendFieldComponent } from '../form';

import './GiveawayModalComponent.scss';

const FORM_NAME = 'giveaway-form';

class GiveawayModalComponent extends React.Component {
    componentWillUnmount() {
        const { reset } = this.props;

        reset();
    }

    submit = () => {
        const {
            sendGiveawayParticipationRequest,
            termsChecked,
            registerChecked,
            contest
        } = this.props;

        if (termsChecked && registerChecked && contest) {
            sendGiveawayParticipationRequest({
                terms: termsChecked,
                register: registerChecked,
                contestId: contest.id
            });
        }
    };

    render() {
        const {
            i18n,
            requestSubmit,
            errorSubmit,
            errorMessage,
            successSubmit,
            termsChecked,
            registerChecked,
            submit
        } = this.props;

        return (
            <div className="modal-giveaway">
                <div className="body">
                    <div className="title">
                        <p>{convertHtmlToReactDomWithParams(i18n.TITLE_1)}</p>
                        <p>{convertHtmlToReactDomWithParams(i18n.TITLE_2)}</p>
                        <p>{convertHtmlToReactDomWithParams(i18n.TITLE_3)}</p>
                    </div>

                    <div className="rules">
                        <ol>
                            <li>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/giveaway/calendar.svg`}
                                    alt=""
                                    width="70"
                                    height="70"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                <div className="texte">
                                    <p>{convertHtmlToReactDomWithParams(i18n.TEXT_1)}</p>
                                </div>
                            </li>
                            <li>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/giveaway/coupon.svg`}
                                    alt=""
                                    width="70"
                                    height="70"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                <div className="texte">
                                    <p>{convertHtmlToReactDomWithParams(i18n.TEXT_2)}</p>
                                </div>
                            </li>
                            <li>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/giveaway/bags.svg`}
                                    alt=""
                                    width="70"
                                    height="70"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                <div className="texte">
                                    <p>{convertHtmlToReactDomWithParams(i18n.TEXT_3)}</p>
                                </div>
                            </li>
                        </ol>
                    </div>

                    <div className="checkboxes">
                        <FormComponent
                            form={FORM_NAME}
                            classNameInputContainer="grid-3 has-gutter"
                            onSubmit={this.submit}
                            requestSubmit={requestSubmit}
                            errorSubmit={errorSubmit}
                            hideButton>
                            <CheckboxInputFieldComponent
                                name="terms"
                                classNameInputContainer="full"
                                options={[
                                    {
                                        label: (
                                            <p>
                                                {convertHtmlToReactDomWithParams(i18n.CHECKBOX_1)}
                                            </p>
                                        ),
                                        value: 1
                                    }
                                ]}
                                disabled={registerChecked}
                            />
                            <CheckboxInputFieldComponent
                                name="register"
                                classNameInputContainer="full"
                                options={[
                                    {
                                        label: convertHtmlToReactDomWithParams(i18n.CHECKBOX_2),
                                        value: 1
                                    }
                                ]}
                                disabled={!termsChecked || (registerChecked && !errorSubmit)}
                                onClick={() => termsChecked && submit(FORM_NAME)}
                            />
                            <React.Fragment>
                                {errorSubmit && (
                                    <LegendFieldComponent classNameInputContainer="color-err full">
                                        {errorMessage}
                                    </LegendFieldComponent>
                                )}
                                {successSubmit && (
                                    <LegendFieldComponent classNameInputContainer="success full">
                                        {i18n.SUCCESS_MESSAGE}
                                    </LegendFieldComponent>
                                )}
                            </React.Fragment>
                        </FormComponent>
                    </div>
                </div>
                <div className="footer">{i18n.FOOTER_TEXT}</div>
            </div>
        );
    }
}

GiveawayModalComponent.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = state => {
    const termsChecked = formValueSelector(FORM_NAME)(state, 'terms') || false;
    const registerChecked = formValueSelector(FORM_NAME)(state, 'register') || false;

    return {
        i18n: state.i18n.page.GIVEAWAY_MODAL,
        errorSubmit: !isEmpty(state.giveaway.error),
        errorMessage: state.giveaway.error || '',
        requestSubmit: state.giveaway.fetching || false,
        successSubmit: state.giveaway.successGiveawayParticipationSubmit,
        termsChecked,
        registerChecked,
        contest: state.giveaway.contest
    };
};
const mapDispatchToProps = {
    sendGiveawayParticipationRequest,
    reset,
    submit
};

export default connect(mapStateToProps, mapDispatchToProps)(GiveawayModalComponent);



// WEBPACK FOOTER //
// ./src/components/giveaway/GiveawayModalComponent.js